import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';
import ContentsTab   from 'contents_tab';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class DraftManagementModal extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      manage_modal: false,
      add_modal: false,
    };
  }
  // -------------------------------------------------------
  
  toggleMainModal(flg) {
    this.setState({ manage_modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
  }
  // -------------------------------------------------------
  
  toggleAddModal(flg) {
    this.setState({ add_modal: flg });
  }
  // -------------------------------------------------------
  
  setAccount(user_id, authority, mode) {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/draft/set_management', { user_id: user_id, authority: authority, draft_id: detail.id, project_id: detail.project_id, mode: mode },
      function(res){
        this.props.change_ev.bind(this)();
        this.toggleAddModal.bind(this)(false);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  set_delete(user_id, email) {
    let chk = confirm('「'+ email +'」さんを担当者を外してもよろしいですか？');
    if( chk == false ) return;
    
    this.setAccount.bind(this)(user_id, 0, 'delete');
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // ゲストに表示しない
    if( detail.my_authority == 0 ) return null;
    
    let master_accounts = [];
    detail.draft_management.accounts.map((d) => { if( d.authority == 99 ) master_accounts.push(d); });
    
    return (
      <div className="management-header">
        
        <div className="management-header-box">
          <p className="name">最高責任者 ({master_accounts.length})</p>
          {( detail.my_authority == 99 )
            ? <div className="edit" onClick={this.toggleMainModal.bind(this, true)}>編集</div>
            : <div className="edit" onClick={this.toggleMainModal.bind(this, true)}>確認</div>
          }
          
          <ul className="accounts">
            { master_accounts.map((d, key) => {
              if( key >= 6 ) return null;
              
              return (
                <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip><b>{d.name}<span className="email">({d.email})</span></b></Tooltip>}>
                  <li><img src={d.thumbnail} /></li>
                </OverlayTrigger>
              );
            })}
          </ul>
        </div>
        
        <ContentsModal
          view      = {this.state.manage_modal}
          width     = {400}
          height    = {300}
          close_ev  = {this.toggleMainModal.bind(this, false)}
          html      = {
            <div className="modal-item">
              <div className="management">
                <div className="management-box">
                  <h6>最高責任者</h6>
                  <ul className="management-accounts">
                    { master_accounts.map((d, key) => {
                      let is_checked = (d.is_checked == 1) ? 'on' : 'off';
                      return (
                        <li key={key}>
                          <b>{d.name}</b><span className="email">({d.email})</span>
                          
                          { (detail.my_authority == 99 && (d.authority != 99 || (d.authority == 99 && master_accounts.length >= 2))) && 
                            <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>担当者から外す</Tooltip>}>
                              <i className="material-icons account-remove" onClick={this.set_delete.bind(this, d.user_id, d.email)}>close</i>
                            </OverlayTrigger>
                          }
                        </li>
                      );
                    })}
                    
                    { (detail.my_authority == 99) &&
                      <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>最高責任者を追加する</Tooltip>}>
                        <li className="add" onClick={this.toggleAddModal.bind(this, true)}><i className="material-icons">add</i></li>
                      </OverlayTrigger>
                    }
                  </ul>
                </div>
                
                <ContentsModal
                  view      = {this.state.add_modal}
                  width     = {350}
                  height    = {200}
                  close_ev  = {this.toggleAddModal.bind(this, false)}
                  html      = {
                    <div className="modal-item draft-management-modal">
                      <ManagementSelect mode="candidate" list={detail.draft_management.candidate} set_ev={this.setAccount.bind(this)} />
                    </div>
                  }
                />
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class ManagementSelect extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      is_active: false,
    };
  }
  // -------------------------------------------------------
  
  change() {
    let user_id = this.user_id.value;
    this.setState({ is_active: ( user_id == 'none' ) ? false : true });
  }
  // -------------------------------------------------------
  
  submit() {
    let user_id = this.user_id.value;
    let authority = 99;
    //try { authority = this.authority.value; } catch(e) {};
    
    this.props.set_ev.bind(this)(user_id, authority, 'register');
  }
  // -------------------------------------------------------
  
  render() {
    let list = this.props.list;
    if( list.length == 0 ){
      return <div className="none">登録可能なアカウントがありません {(this.props.mode == 'guests') && <p>※プロジェクトのゲストに対象が含まれているかご確認ください</p> }</div>;
    }
    
    return (
      <div className="management-select">
        
        <h2>アカウントの登録</h2>
        
        <div className="management-select-account">
          <h5>アカウント</h5>
          <div className="selectbox">
            <select ref={(input) => { this.user_id = input }} onChange={this.change.bind(this)}>
              <option value="none">アカウントを選択してください</option>
              { list.map((d, key) => {
                return <option key={key} value={d.id}>{d.name} ({d.email})</option>
               })}
            </select>
          </div>
        </div>
        
        { (this.state.is_active == true)
          ? <div className="button" onClick={this.submit.bind(this)}>最高責任者に追加</div>
          : <div className="button off">最高責任者に追加</div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftManagementModal;